<div class="file-upload-container" [class]="containerClass">
    <!-- Custom Input-Style Upload -->
    <div class="custom-file-input" [class.disabled]="disabled" [class.has-files]="hasFiles">
        <!-- File Input (Hidden) -->
        <input
            #fileInput
            type="file"
            [disabled]="disabled"
            [accept]="acceptedTypes"
            [multiple]="multiple"
            (change)="onFileSelected($event)"
            style="display: none"
        />

        <!-- Input Field Display -->
        <div
            class="input-display"
            [class.drag-over]="isDragOver"
            (click)="!disabled && fileInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
        >
            <div class="input-actions">
                <button type="button" class="browse-button" (click)="onBrowseClick($event)">
                    <lucide-icon [img]="Upload" class="browse-icon w-4 h-4"></lucide-icon>
                    Browse
                </button>
            </div>

            <div class="input-content">
                @if (!hasFiles) {
                <span class="placeholder-text">{{ placeholder || "Choose file(s)" }}</span>
                } @else { @if (selectedFiles.length === 1) {
                <span class="selected-text">{{ selectedFiles[0].file.name || "Unknown file" }}</span>
                } @else {
                <span class="selected-text">{{ selectedFiles.length }} files selected</span>
                } }
            </div>
        </div>

        <!-- Selected Files List (Collapsed by default) -->
        @if (hasFiles && selectedFiles.length > 0) {
        <div class="files-list" [class.expanded]="showFilesList">
            <div class="files-header" (click)="toggleFilesList()">
                <span class="files-count">{{ selectedFiles.length }} file(s) selected</span>
                <lucide-icon
                    [img]="ChevronDown"
                    class="w-4 h-4 text-primary"
                    [class.expand-icon]="showFilesList"
                ></lucide-icon>
            </div>

            @if (showFilesList) {
            <div class="files-content">
                @for (fileItem of selectedFiles; track fileItem.id) { @if (fileItem && fileItem.file) {
                <div class="file-item">
                    <div class="file-info">
                        @if (fileItem.isImage && fileItem.previewUrl && showImageThumbnails) {
                        <img
                            [src]="fileItem.previewUrl"
                            [alt]="fileItem.file.name || 'File preview'"
                            class="file-thumbnail clickable"
                            (click)="viewImageInNewTab($event, fileItem)"
                            [title]="'Click to view ' + (fileItem.file.name || 'image') + ' in new tab'"
                        />
                        } @else {
                        <lucide-icon [img]="File" class="file-icon"></lucide-icon>
                        }

                        <div class="file-details">
                            <span class="file-name">{{ fileItem.file.name || "Unknown file" }}</span>
                            <span class="file-size">{{ formatFileSize(fileItem.file.size) }}</span>
                        </div>
                    </div>

                    @if (!disabled) {
                    <button
                        type="button"
                        class="remove-button rounded-full"
                        (click)="removeFile($event, fileItem.id)"
                        [attr.aria-label]="'Remove ' + (fileItem.file.name || 'file')"
                    >
                        <lucide-icon [img]="X" class="w-4 h-4"></lucide-icon>
                    </button>
                    }
                </div>
                } }
            </div>
            }
        </div>
        }
    </div>

    @if (showError && errorMessage) {
    <!-- Error Display -->
    <div class="error-message">
        <lucide-icon [img]="X" class="error-icon"></lucide-icon>
        {{ errorMessage }}
    </div>
    } @if (showRequirements) {
    <!-- File Requirements -->
    <div class="file-requirements">
        <p class="requirements-text">{{ requirementsText }}</p>
    </div>
    }
</div>
